import { AppcuesSDK } from './types';

class AppcuesService {
  private appcues: AppcuesSDK | undefined;

  constructor() {
    this.appcues = window['Appcues'];
  }

  public anonymous: AppcuesSDK['anonymous'] = () => this.appcues?.anonymous();

  public clearShow: AppcuesSDK['clearShow'] = () => this.appcues?.clearShow();

  public debug: AppcuesSDK['debug'] = (enable = true) => this.appcues?.debug(enable);

  public group: AppcuesSDK['group'] = (groupId, args) => this.appcues?.group(groupId, args);

  public identify: AppcuesSDK['identify'] = (userId, args) => this.appcues?.identify(userId, args);

  public off: AppcuesSDK['off'] = (event, callback, context) =>
    this.appcues?.off(event, callback, context);

  public on: AppcuesSDK['on'] = (event, callback, context) =>
    this.appcues?.on(event, callback, context);

  public once: AppcuesSDK['once'] = (event, callback, context) =>
    this.appcues?.once(event, callback, context);

  public page: AppcuesSDK['page'] = () => this.appcues?.page();

  public reset: AppcuesSDK['reset'] = () => this.appcues?.reset();

  public show: AppcuesSDK['show'] = contentId => this.appcues?.show(contentId);

  public track: AppcuesSDK['track'] = (eventName, eventArgsrgs) =>
    this.appcues?.track(eventName, eventArgsrgs);
}

export const Appcues = new AppcuesService();
